import { jsx as _jsx } from "react/jsx-runtime";
import Toast from '../Toast';
import { useToast } from '../../contexts/ToastContext';
const ToastContainer = () => {
    const { toasts, removeToast } = useToast();
    return (_jsx("div", { className: "fixed bottom-5 right-5 z-50 flex flex-col gap-2 max-w-sm", children: toasts.map(({ id, message, type }) => (_jsx(Toast, { id: id, message: message, type: type, onClose: removeToast }, id))) }));
};
export default ToastContainer;
